<template>
  <el-container>
    <el-main>
      <el-select v-if="orgType == 1" placeholder="" size="small" placeholder="机构" v-model="orgCode" @change="changeOrg" style="margin-right: 10px;">
        <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
      </el-select><br>
      <el-button
          type="success"
          icon="el-icon-circle-plus-outline"
          size="small"
          round
          @click="addBanner"
          class="but-cls"
      >添加轮播图</el-button><span style="color: #6d6d6d;font-size: 12px; margin-left: 8px">支持.jpg,.gif,.png格式，最多可上传10张图片,最佳尺寸：1200X440，5M以内</span>
      <el-dialog
          title=""
          :visible.sync="showBan"
          width="80%"
          :close-on-click-modal=false
          :before-close="handleDialogClose"
      >
        <div class="banner" v-if="showBan">
          <div class="item">
            <img width="1200" height="440" :src="bannerData[currentIndex].imageUrl" :class="[bannerData[currentIndex].linkUrl?'point_':'']" @click="go(bannerData[currentIndex])">
          </div>
          <div class="page" v-if="this.bannerData.length > 1">
            <ul class="slide">
              <li class="slide_li" @click="gotoPage(prevIndex)">&lt;</li>
              <li class="slide_li" v-for="(item,index) in bannerData" @click="gotoPage(index)" :class="{'current':currentIndex == index}">  {{index+1}}</li>
              <li class="slide_li" @click="gotoPage(nextIndex)">&gt;</li>
            </ul>
          </div>
        </div>
      </el-dialog>
      <el-table
          :data="bannerData"
          style="width: 100%">
        <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
        <el-table-column
            label="PC图片"
            width="380"
            height="110"
        >
          <template slot-scope="scope" >
            <div class="img_div" v-if="scope.row.imageUrl">
              <img  :src="scope.row.imageUrl" width="300" height="110"  @hover="showUpload(scope.row)">
              <a href="#" @click="updateImg(scope.row)">
                <div class="mask" >
                  <h3>更换图片</h3>
                </div>
              </a>
            </div>
            <div v-if="!scope.row.imageUrl" class="add_img" @click="updateImg(scope.row)">+</div>
           
          </template>
        </el-table-column>
        <el-table-column
            label="APP图片"
            width="380"
            height="110"
        >
          <template slot-scope="scope" >
            <div class="img_div" v-if="scope.row.imageAppUrl">
              <img  :src="scope.row.imageAppUrl" width="300" height="110"  @hover="showUpload(scope.row)">
              <a href="#" @click="updateAppImg(scope.row)">
                <div class="mask" >
                  <h3>更换图片</h3>
                </div>
              </a>
            </div>
            <div v-if="!scope.row.imageAppUrl" class="add_img" @click="updateAppImg(scope.row)">+</div>
    
          </template>
        </el-table-column>
        <el-table-column
            label="链接地址"
            width="400">
          <template slot-scope="scope">
            <el-input v-model="scope.row.linkUrl" style="width: 95%" ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
                @click="imgUp(scope.row, scope.$index)"
                type="text"
                size="small"
            >上移</el-button>
            <el-button
                @click="imgDown(scope.row, scope.$index)"
                type="text"
                size="small"
            >下移</el-button>
            <el-button
                @click="deleteImg(scope.$index, scope.row)"
                type="text"
                size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <input type="file" id="inputFile" accept="image/*" @change="handleFile" class="hiddenInput"/>
      <div style="width: 100%;text-align: center" >
        <el-button @click="showBanner">预 览</el-button>
        <el-button type="primary" @click="saveBanner">保 存</el-button>
      </div>
    </el-main>
  </el-container>
  
  
</template>

<script>
  export default {
    name: 'banner',
    data() {
      return {
        bannerData: [],
        uploadType: '',
        showBan: false,
        currentRow: {},
        currentIndex: 0,   //默认显示图片
        timer: null,    //定时器
        org: [],
        orgCode: '',
        orgType: '',
      };
    },
    computed: {
      //上一张
      prevIndex() {
        if(this.currentIndex == 0) {
          return this.bannerData.length - 1;
        }else{
          return this.currentIndex - 1;
        }
      },
      //下一张
      nextIndex() {
        if(this.currentIndex == this.bannerData.length - 1) {
          return 0;
        }else {
          return this.currentIndex + 1;
        }
      }
    },
    methods: {
      handleDialogClose() {
        clearInterval(this.timer);
        this.showBan = false;
      },
      gotoPage(index) {
        this.currentIndex = index;
      },
      showBanner() {
        this.timer = setInterval(() => {
          this.gotoPage(this.nextIndex)
        }, 3000)
        this.showBan = true;
      },
      changeOrg() {
        this.selectBanner();
      },
      selectBanner() {
        let params = {
          orgCode: this.orgCode,
          page: 1,
          size: 999
        }
        this.https.fetchPost('/webRotation/search', params, 'json').then((data) => {
          let code = data.data.code;
          if(code == 200) {
            if(data.data.data) {
              this.bannerData = data.data.data;
            } else {
              this.bannerData = [];
            }
          }
        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      updateImg(row) {
        this.currentRow = row;
        this.uploadType = 'pc';
        console.log(this.$el.querySelector('.hiddenInput'));
        this.$el.querySelector('.hiddenInput').click();
      },
      updateAppImg(row) {
        this.currentRow = row;
        this.uploadType = 'app';
        console.log(this.$el.querySelector('.hiddenInput'));
        this.$el.querySelector('.hiddenInput').click();
      },
      handleFile(e) {
        let $target = e.target || e.srcElement
        let file = $target.files[0]
        let isImg = file.type == 'image/jpg' || file.type  == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/gif';
        if(!isImg){
          this.$message.error('操作失败：支持.jpg,.gif,.png格式');
          return;
        }
        let fileSizeLt2 = file.size/1024/1024 > 5 ;
        if(fileSizeLt2){
          this.$message.error('操作失败：图片最大5M');
          return;
        }
        let that = this;
        this.ajax(this.https.baseURL + '/file/fdfs_upload',file,function(res){
          res = JSON.parse(res);
          if(res.code == 200) {
            if(that.uploadType == 'app') {
              that.currentRow.imageAppUrl = res.data.filePath;
            }
            if(that.uploadType == 'pc') {
              that.currentRow.imageUrl = res.data.filePath;
            }
            let input = document.getElementById('inputFile')
            input.value = "";
          }
        })
      },
      
      ajax(url,data,fn){
        const xhr =new XMLHttpRequest();
        xhr.onreadystatechange =function(){
          if(xhr.readyState ===4 && xhr.status ===200){
            fn(xhr.responseText);
          }
        }
        const formData=new FormData();
        formData.append('file',data);
        xhr.open("post",url,true);
        xhr.setRequestHeader("Authentication",localStorage.getItem("token"));
        xhr.send(formData);
      },
      showUpload() {
      
      },
      imgUp(row,index) {
        if(row.imageUrl ) {
          if(index == 0) {
            this.$message.error('已置顶，无法上移！');
            return;
          }
          this.bannerData[index] = this.bannerData.splice(index-1, 1, this.bannerData[index])[0];
        } else {
          this.$message.error('无法移动！');
        }
      },
      imgDown(row,index) {
        if(row.imageUrl ) {
          if(index == this.bannerData.length -1) {
            this.$message.error('已在最底，无法上移！');
            return;
          }
          let nextRow = this.bannerData[index+1];
          if(!nextRow.imageUrl) {
            this.$message.error('已在最底，无法上移！');
            return;
          }
          this.bannerData[index] = this.bannerData.splice(index+1, 1, this.bannerData[index])[0];
          return;
        } else {
          this.$message.error('无法移动！');
        }
        
      },
      deleteImg(index, row) {
        // /webRotation/deleteRotation
        if(!row.rotationId) {
          if(!row.imageUrl) {
            this.bannerData.splice(index,1);
            return;
          }
          this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.bannerData.splice(index,1);
          }).catch(err=>{
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          })
        }
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            rotationIdList: [row.rotationId]
          };
          this.https.fetchPost('/webRotation/deleteRotation', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.selectBanner();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      addBanner() {
        let banner = {
          imageUrl: '',
          imageAppUrl: '',
          linkUrl: ''
        }
        if(this.bannerData.length >= 10) {
          this.$message.error('最多可上传10张图片!');
          return;
        }
        this.bannerData.push(banner)
      },
      saveBanner() {
        for(let item of this.bannerData) {
          if(!item.imageUrl || item.imageUrl == "" || !item.imageAppUrl || item.imageAppUrl == "") {
            this.$message.error('图片不能为空！');
            return;
          }
          if(item.linkUrl.length>200) {
            this.$message.error('链接地址不能超过200字符！');
            return;
          }
          if(item.linkUrl) {
            if(item.linkUrl.substr(0,8) != "https://" && item.linkUrl.substr(0,7) != "http://") {
              this.$message.error('链接地址格式错误！');
              return;
            }
          }
          
        }
        let params = {
          orgCode: this.orgCode,
          webRotationList: this.bannerData
        }
        this.https.fetchPost('/webRotation/saveRotationList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.$message({
              type: 'success',
              message: "保存成功"
            });
          } else {
            this.$message({
              type: 'info',
              message: "保存失败："+msg
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
            if(this.org.length > 0) {
              this.orgCode = this.org[0].orgCode;
            }
            this.selectBanner();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      go(row) {
        if(row.linkUrl) {
          window.open(row.linkUrl);
        }
      },
    },
    
    created: function() {
      this.orgType = this.$store.state.orgType;
      this.orgCode = this.$store.state.orgCode;
      this.changeOrg();
      this.selectOrg();
    }
  };
</script>

<style >
  .hiddenInput {
    display: none;
  }

  .img_div {
  }
  .mask {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 300px;
    height: 110px;
    line-height: 110px;
    background: rgba(101, 101, 101, 0.6);
    color: #ffffff;
    opacity: 0;
  }
  .mask h3 {
    text-align: center;
  }
  .img_div a:hover .mask {
    opacity: 1;
  }
  
  .add_img {
    width: 300px;
    height: 110px;
    font-size: 60px;
    text-align: center;
    line-height: 110px;
    cursor: pointer;
    background: rgba(101, 101, 101, 0.6);
  }
  .slide .slide_li {
    list-style: none;
    float: left;
    width: 30px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    color: rgba(255,255,255,.8);
    font-size: 14px;
  }
  
  .banner {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    margin-top: 60px;
  }
  .banner img {
    width: 100%;
    display: block;
  }
  .banner .page {
    background: rgba(0,0,0,.5);
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
  }
  .banner .page ul {
    float: right;
  }
  .current {
    color: #ff6700;
  }
  .point_ {
    cursor: pointer;
  }
</style>
